<p-tree
  [value]="treeNodes()"
  selectionMode="single"
  [propagateSelectionUp]="false"
  [propagateSelectionDown]="false"
  (onNodeSelect)="onNodeSelect($event)"
></p-tree>
